export const basicModalSubTitle = [
    {
        text: "Add different types of modal with the help of ",
        code: 'data-bs-target'
    },
    {
        text: ' attribute.'
    }
];

export const scrollingModalData = [
    {
        class: 'mt-3',
        text: "For a site to be successful, a designer must be able to communicate their ideas, chat with a firm about what they want, and inquire about the target audience."
    },
    {
        class: 'mt-2',
        text: "As a web designer, you either prefer to work freelance for several different businesses at once or you may choose to work for just one. In either case, you'll need good time management skills to keep several projects moving forward."
    },
    {
        class: 'mt-2',
        text: "Although a designer doesn't write the code that makes a site work, it doesn't hurt to have a basic understanding of HTML or CSS to make minor adjustments to a site. You'll find it simpler to edit templates, improve typefaces, or change item placements if you have a basic understanding of how things work."
    },
    {
        class: 'my-2',
        text: "Most businesses employ a certain font or typography so that clients can quickly distinguish them from their rivals. Since designers now have access to a wider variety of fonts, firms may more easily and precisely communicate their brands through typography."
    },
    {
        class: 'mt-3',
        text: "User research, persona creation, building wireframes and interactive prototypes, and testing ideas are among the common tasks of a UX designer. These duties can differ greatly between organizations."
    },
    {
        class: 'mt-3',
        text: "Create solutions that will be helpful for the issues and situations that exist right now, not for those that will. With the right materials, assist people in organizing their time, completing things more quickly, and optimizing it."
    },
    {
        class: 'mt-3',
        text: "Based on the data received from users, improve them. Adapt existing solutions to the requirements, hopes, difficulties, and expectations of users."
    },
    {
        class: 'mt-3',
        text: "Keep in mind that you are creating solutions to particular challenges for a particular population living in a particular habitat. Always remember to correctly contextualise your thoughts and determine whether they are actually appropriate for the situation. It's sometimes necessary to concede that a digital solution is not the most appropriate choice in a certain circumstance."
    }
];

export const tooltipData = [
    { id: 'Tooltip11', content: 'This link', text: 'and ' },
    { id: 'Tooltip12', content: 'that link', text: 'have tooltips on hover.' }
];

//sizes modal
export const sizeModalSubTitle = [
    {
        text: "Set the different size of modal using "
    },
    {
        code: '.bs-example-modal-(xl,lg,sm,fullscreen).'
    }
];

export const fullScreenModalData = [
    {
        title: 'Web Design ',
        text: 'We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.'
    },
    {
        title: 'Content Marketing ',
        text: "Through better opportunities and knowledgeable marketing strategies, we aid business funnel.We won't only hit the target; instead, we'll aim higher and surpass the objectives."
    },
    {
        title: 'PPC ',
        text: "Customized advertising to increase visitors and improve conversion.To increase retention, identify the correct audience and remarket to them."
    },
    {
        title: 'UX Designer ',
        text: "The capacity to comprehend and experience other people's feelings is known as empathy.A positive consumer experience is prioritised by UX.The finest UX designers spend time studying individuals and their tendencies because of this. Designers may produce goods that genuinely engage and excite customers by having a thorough understanding of the end consumers."
    }
];

export const largeModalData = [
    "No matter how talented you are as a content writer or creator, you will always fail if you don't have a clear set of goals.",
    "First of all, without goals, there is no way to determine your success. Additionally, you lack direction.",
    "Together with your team, respond to the following questions to make sure they are:",
    'What must you achieve, and by when?',
    'How will you evaluate your level of success?',
    'Can you accomplish it with the available resources?',
    'Does it advance your core business aims?'
];

//fullscreen modal
export const fullscreenModalSubTitle = [
    {
        text: "Another override is the option to pop up a modal that covers the user viewport, available via modifier classes that are placed on a"
    },
    {
        code: ' .modal-dialog.'
    }
];

export const belowsmData = [
    'For a site to be successful, a designer must be able to communicate their ideas, chat with a firm about what they want, and inquire about the target audience.',
    'Most businesses employ a certain font or typography so that clients can quickly distinguish them from their rivals.Since designers now have access to a wider variety of fonts, firms may more easily and precisely communicate their brands through typography.',
    'User research, persona creation, building wireframes and interactive prototypes, and testing ideas are among the common tasks of a UX designer.These duties can differ greatly between organizations.',
    "Keep in mind that you are creating solutions to particular challenges for a particular population living in a particular habitat.Always remember to correctly contextualise your thoughts and determine whether they are actually appropriate for the situation. It's sometimes necessary to concede that a digital solution is not the most appropriate choice in a certain circumstance."
];

//Centered Modal
export const centeredModalSubTitle = [
    {
        text: "Use ",
        code: '.modal-dialog-centered '
    },
    {
        text: 'to set the centered modal.'
    }
]

//nested modal
export const nestedModalSubTitle = [
    {
        text: "To set the nested modal use the ",
        code: 'exampleTogglelabel.'
    }
];

export const nestedModalImage = ['whatapp', 'instagram', 'facebook']

// static modal
export const staticModalSubTitle = [
    {
        text: "To set static backdrop , use ",
        code: "staticBackdrop "
    },
    {
        text: "attributes."
    }
];

//custom modal
export const customModalSubTitle = [
    {
        text: "Custom Modal make by Admiro.",
    }
]

export const demoModalData = [
    {
        class: '1,908',
        text: 'Posts'
    },
    {
        class: '34.0k',
        text: 'Followers'
    },
    {
        class: '897',
        text: 'Following'
    }
]

export const balanceIconWrapData = [
    {
        id: 1,
        color: 'danger',
        text: 'Investment',
        rate: 78.8,
        badge: '-11.67'
    },
    {
        id: 2,
        color: 'success',
        text: 'Cash Back',
        rate: 19.7,
        badge: '+10.67'
    }
]